import React, { useState } from 'react';
import AnnouncementBanner from '../../../../Elements/AnnouncementBanner';
import FigmaButton from '../../../../Elements/FigmaButton';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import { getReadyForInvoicingBanner } from '../../../../Helpers/invoiceAutomationStatusHelper';
import InvoiceAutomationRunNow from './InvoiceAutomationRunNow';

// The banner over a project's Ready for Invoicing jobs when the project has an automatic invoicing setup, with Run Now
// while the setup is Active. onRunNowClose is called when the Run Now window closes.
export default function InvoiceAutomationReadyBanner({
  projectId = null,
  projectName = '',
  isActive = null,
  runSchedule = null,
  onRunNowClose = () => {},
}) {
  const [isRunNowOpen, setIsRunNowOpen] = useState(false);
  const banner = getReadyForInvoicingBanner(isActive, runSchedule);
  if (banner === null) {
    return null;
  }

  function closeRunNow() {
    setIsRunNowOpen(false);
    onRunNowClose();
  }

  const runNowButton = isActive ? (
    <FigmaButton
      label='Run Now'
      type={ButtonTypeEnum.NormalNormal}
      color={ButtonColorsEnum.Primary}
      roleKey='invoice_automation_edit'
      onClick={() => setIsRunNowOpen(true)}
    />
  ) : null;
  return (
    <>
      <AnnouncementBanner
        tone={banner.tone}
        iconName='fa-solid fa-file-invoice'
        title={banner.title}
        actions={runNowButton}
        className='mb-3'
      >
        {banner.text}
      </AnnouncementBanner>
      {isRunNowOpen && (
        <InvoiceAutomationRunNow
          projectId={projectId}
          projectName={projectName}
          onClose={closeRunNow}
        />
      )}
    </>
  );
}
